import React from 'react'
import { connect } from 'react-redux'
import agent from '../agent'
import numberHelper from '../util/numberFormatter'
import Loading from './widgets/Loading'
import TransactionList from './widgets/TransactionList'
import Header from './widgets/Header'
import QRCode from './widgets/QRCode'
import {
  PAY_LOADED
} from '../constants/actionTypes'
import { BASE_COIN_SYMBOL } from '../constants/config'
const mapStateToProps = state => ({
  ...state.common,
  baseAccount: state.common.baseAccount,
  recentTransactions: state.common.recentTransactions,
  newTransactionAdded: state.common.newTransactionAdded
})

const mapDispatchToProps = dispatch => ({
  onLoad: (payload) => {
    dispatch({ type: PAY_LOADED, payload })
  }
})

class Pay extends React.Component {
  constructor() {
    super()
    this.state = {
      notes: '',
      amount: '10',
    }
    this.updateState = field => ev => {
      const state = this.state;
      const newState = Object.assign({}, state, { [field]: ev.target.value });
      this.setState(newState);
    }
    this.keyPress = (e) => {
      // ev.preventDefault()
      if (e.charCode !== 13) return
    }
  }

  componentWillMount() {
    let payload = null
    if (this.props.baseAccount) {
      payload = agent.Common.getTransactions(this.props.baseAccount.external)
    }

    this.props.onLoad(payload)
  }

  componentWillUnmount() {
  }
  render() {
    if (!this.props.baseAccount) {
      return (
          <Loading />
      )
  }
    const amount = this.state.amount
    const notes = this.state.notes
    const payment = {
      address: this.props.baseAccount.external,
      symbol: this.props.baseAccount.symbol,
      notes: this.state.notes,
      amount: this.state.amount
    }
    const jsonStr = JSON.stringify({ payment })
    return (
      <div>
        <Header selected={'pay'} />
        <div id="main"><div id="main-wrap">
          <div id="content">
            <h2>Payment Info</h2>
            <div className="FormItem">
              <label>Reference</label>
              <input type="text" value={notes} onChange={this.updateState('notes')} />
            </div>
            <div className="FormItem">
              <label>Amount</label>
              <input type="text" value={amount} onChange={this.updateState('amount')} onKeyPress={(e) => this.keyPress(e)} />
            </div>
            <div className="FormItem">
              <label>Currency</label>
              <span className="ReferenceInput">{this.props.baseAccount.symbol}</span>
            </div>
            <h2>Payment Code</h2>
            <div id="PaymentQR">
              {/* render QR which is readable by XIF App, {address}, but add additional elements, amount: and note: (we will update the XIF app to support note and amount) */}
              <QRCode value={jsonStr} />
            </div>

            <h2>Transactions</h2>
            <TransactionList data={{ recentTransactions: this.props.recentTransactions, newTransactionAdded: this.props.newTransactionAdded }} />
          </div>
        </div></div>
      </div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Pay)
